<template>
    <div class="register-testimonial flex">
        <VueSlickCarousel v-bind="settings">
            <div
                v-for="(testimonial, index) in testimonials"
                :key="index"
                class="testimonial"
            >
                <p class="text">
                    <span class="decorator">"</span>
                    <span v-html="testimonial.content" />" <!-- eslint-disable-line vue/no-v-html -->
                </p>
                <div class="testimonial-card flex">
                    <div class="image">
                        <img :src="testimonial.coverImage" :alt="testimonial.podcastName">
                    </div>
                    <div class="content">
                        <span class="name">{{ testimonial.authorName }}</span>
                        <span class="description">{{ testimonial.podcastName }}</span>
                    </div>
                </div>
            </div>
        </VueSlickCarousel>
    </div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel';

export default {
    components: { VueSlickCarousel },
    // eslint-disable-next-line require-jsdoc
    data: () => ({
        settings: {
            dots: true,
            arrows: false,
            dotsClass: 'slick-dots custom-dot-class',
            edgeFriction: 0.35,
            infinite: true,
            speed: 500,
            autoplaySpeed: 6000,
            autoplay: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            adaptiveHeight: true,
        },

        testimonials: [
            {
                coverImage: 'images/testimonials/color-your-dreams.jpg',
                podcastName: 'Color Your Dreams®',
                authorName: 'Elaine Lou Cartas',
                content: 'Ever since I started using Fusebox, it has increased my podcast downloads by 13%. I love how easily Fusebox is integrated into my website. Having Fusebox on my website establishes my expertise and authority and makes it easy for people to know I have a podcast.',
            },
            {
                coverImage: 'images/testimonials/crunches-and-cosmos.jpg',
                podcastName: 'Crunches and Cosmos',
                authorName: 'Mickie Carter',
                content: 'I love the podcast page player! The customizations look clean and professional on my website.',
            },
            {
                coverImage: 'images/testimonials/my-business-playbook.jpg',
                podcastName: 'My Business Playbook',
                authorName: 'Laura Higgins',
                content: 'I love Fusebox. We’ve loved having a super interactive player on our website that can also house our lead magnet download.',
            },
            {
                coverImage: 'images/testimonials/leave-no-doubt.jpg',
                podcastName: 'Leave No Doubt',
                authorName: 'Joe Partington & Ben Young',
                content: 'We love the fusebox player, we use it to host our show on our website and it quickly and easily allows users to look through the back catalog or play the most recent show. The interface is clean, easy, and intuitive.',
            },
            {
                coverImage: 'images/testimonials/thyroid-warrior-podcast.jpg',
                podcastName: 'Thyroid Warrior Podcast',
                authorName: 'Ebony Williams',
                content: 'I love Fusebox. It integrates seamlessly with my website and I have recently started using transcription, which I enjoy. I used it on my former WordPress website and loved it!',
            },
            {
                coverImage: 'images/testimonials/how-to-buy-a-home.jpg',
                podcastName: 'How to Buy a Home',
                authorName: 'David Sidoni',
                content: 'Fusebox creates a user-friendly playlist for my listeners to EASILY find all my evergreen educational content which is HUGE for me with an educational podcast.',
            },
            {
                coverImage: 'images/testimonials/pickled-parables.jpg',
                podcastName: 'Pickled Parables',
                authorName: 'Jesse Turkington',
                content: 'I was looking for better audio players for my website and Fusebox offers everything I wanted. Great customization!',
            },
            {
                coverImage: 'images/testimonials/the-toxic-leadership-podcast.jpg',
                podcastName: 'The Toxic Leadership Podcast',
                authorName: 'Kevin Sansberry',
                content: 'Fusebox facilitated listeners from around the world to access podcast episodes with the click of a button. The Fusebox player has been instrumental in supporting me in spreading the word in the mission to detoxify workplaces.',
            },
        ],
    }),
};
</script>
